import { render, staticRenderFns } from "./twitter-logs.vue?vue&type=template&id=79e16fde&"
import script from "./twitter-logs.vue?vue&type=script&lang=js&"
export * from "./twitter-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports